import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, CloudSunIcon, MapPinIcon, BellIcon, UtensilsIcon, WashingMachineIcon, MapIcon, PhoneIcon, MessageCircleIcon, InfoIcon, AlertTriangleIcon } from 'lucide-react';
import Header from '../components/Header';
const Home = () => {
  // In a real app, these would come from an API
  const hasActiveBooking = true;
  const bookingInfo = {
    arrivalDate: '24 juli 2023',
    departureDate: '31 juli 2023',
    spotNumber: '42',
    spotType: 'Comfort kampeerplaats',
    guests: 4
  };
  const currentWeather = {
    temp: 24,
    condition: 'sunny',
    rainChance: 10
  };
  const todayActivities = [{
    time: '10:00',
    title: 'Kinderclub',
    location: 'Recreatieruimte'
  }, {
    time: '14:00',
    title: 'Zwembadspellen',
    location: 'Zwembad'
  }, {
    time: '19:30',
    title: 'Kampvuur',
    location: 'Centrale vuurplaats'
  }];
  const announcements = [{
    id: 1,
    title: 'Zwembad vandaag open tot 21:00!',
    date: 'Vandaag',
    priority: 'normal'
  }, {
    id: 2,
    title: 'Let op: Kans op onweer vanavond',
    date: 'Vandaag',
    priority: 'high'
  }];
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-381">
      <Header title="Camping Olympia" data-id="element-382" />
      <div className="p-4 space-y-4" data-id="element-383">
        {/* Booking Summary */}
        {hasActiveBooking && <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-384">
            <div className="bg-[#f9b30f] p-3" data-id="element-385">
              <h2 className="text-black font-bold" data-id="element-386">Jouw Verblijf</h2>
            </div>
            <div className="p-4" data-id="element-387">
              <div className="flex justify-between mb-2" data-id="element-388">
                <span className="text-sm text-gray-600" data-id="element-389">Aankomst</span>
                <span className="text-sm font-medium" data-id="element-390">
                  {bookingInfo.arrivalDate}
                </span>
              </div>
              <div className="flex justify-between mb-2" data-id="element-391">
                <span className="text-sm text-gray-600" data-id="element-392">Vertrek</span>
                <span className="text-sm font-medium" data-id="element-393">
                  {bookingInfo.departureDate}
                </span>
              </div>
              <div className="flex justify-between mb-2" data-id="element-394">
                <span className="text-sm text-gray-600" data-id="element-395">Standplaats</span>
                <span className="text-sm font-medium" data-id="element-396">
                  {bookingInfo.spotNumber}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-397">
                <span className="text-sm text-gray-600" data-id="element-398">Type</span>
                <span className="text-sm font-medium" data-id="element-399">
                  {bookingInfo.spotType}
                </span>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-100 flex space-x-2" data-id="element-400">
                <Link to="/bookings" className="flex-1 bg-[#f9b30f] text-black py-2 rounded-lg text-center text-sm font-medium" data-id="element-401">
                  Details bekijken
                </Link>
                <Link to="/map" className="flex items-center justify-center bg-gray-100 text-gray-700 py-2 px-3 rounded-lg text-sm font-medium" data-id="element-402">
                  <MapPinIcon size={16} className="mr-1" data-id="element-403" />
                  Op kaart
                </Link>
              </div>
            </div>
          </div>}
        {/* Weather & Activities Quick View */}
        <div className="grid grid-cols-2 gap-4" data-id="element-404">
          <Link to="/weather" className="bg-white rounded-lg shadow-sm p-4 flex flex-col items-center text-center hover:bg-gray-50 transition-colors" data-id="element-405">
            <div className="text-[#f9b30f] mb-1" data-id="element-406">
              {currentWeather.condition === 'sunny' ? <CloudSunIcon size={32} data-id="element-407" /> : <CloudIcon size={32} data-id="element-408" />}
            </div>
            <span className="text-2xl font-bold" data-id="element-409">{currentWeather.temp}°C</span>
            <span className="text-xs text-gray-600 mt-1" data-id="element-410">
              {currentWeather.rainChance}% kans op regen
            </span>
            <span className="text-xs font-medium text-[#f9b30f] mt-2" data-id="element-411">
              Weersvoorspelling
            </span>
          </Link>
          <Link to="/activities" className="bg-white rounded-lg shadow-sm p-4 flex flex-col items-center text-center hover:bg-gray-50 transition-colors" data-id="element-412">
            <div className="text-[#f9b30f] mb-1" data-id="element-413">
              <CalendarIcon size={32} data-id="element-414" />
            </div>
            <span className="text-sm font-bold" data-id="element-415">Vandaag</span>
            <span className="text-xs text-gray-600 mt-1" data-id="element-416">
              {todayActivities.length} activiteiten
            </span>
            <span className="text-xs font-medium text-[#f9b30f] mt-2" data-id="element-417">
              Activiteitenkalender
            </span>
          </Link>
        </div>
        {/* Announcements */}
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-418">
          <div className="flex items-center justify-between mb-3" data-id="element-419">
            <h3 className="font-bold" data-id="element-420">Belangrijke berichten</h3>
            <BellIcon size={18} className="text-[#f9b30f]" data-id="element-421" />
          </div>
          <div className="space-y-3" data-id="element-422">
            {announcements.map(announcement => <div key={announcement.id} className={`p-3 rounded-lg ${announcement.priority === 'high' ? 'bg-red-50 border border-red-100' : 'bg-gray-50'}`} data-id="element-423">
                <div className="flex justify-between items-center mb-1" data-id="element-424">
                  <h4 className={`font-medium text-sm ${announcement.priority === 'high' ? 'text-red-700' : ''}`} data-id="element-425">
                    {announcement.priority === 'high' && <AlertTriangleIcon size={14} className="inline mr-1 text-red-500" data-id="element-426" />}
                    {announcement.title}
                  </h4>
                  <span className="text-xs text-gray-500" data-id="element-427">
                    {announcement.date}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
        {/* Quick Actions */}
        <div data-id="element-428">
          <h3 className="font-bold mb-3" data-id="element-429">Snel naar</h3>
          <div className="grid grid-cols-3 gap-3" data-id="element-430">
            <QuickActionButton to="/facilities" icon={<UtensilsIcon size={20} data-id="element-432" />} label="BBQ Reserveren" data-id="element-431" />
            <QuickActionButton to="/facilities" icon={<div size={20} data-id="element-434" />} label="Fiets Huren" data-id="element-433" />
            <QuickActionButton to="/facilities" icon={<WashingMachineIcon size={20} data-id="element-436" />} label="Wasmachine" data-id="element-435" />
            <QuickActionButton to="/map" icon={<MapIcon size={20} data-id="element-438" />} label="Plattegrond" data-id="element-437" />
            <QuickActionButton to="/contact" icon={<PhoneIcon size={20} data-id="element-440" />} label="Contact" data-id="element-439" />
            <QuickActionButton to="/assistant" icon={<MessageCircleIcon size={20} data-id="element-442" />} label="Assistent" data-id="element-441" />
          </div>
        </div>
        {/* Today's Activities */}
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-443">
          <div className="flex items-center justify-between mb-3" data-id="element-444">
            <h3 className="font-bold" data-id="element-445">Activiteiten vandaag</h3>
            <Link to="/activities" className="text-xs text-[#f9b30f] font-medium" data-id="element-446">
              Alles bekijken
            </Link>
          </div>
          <div className="space-y-3" data-id="element-447">
            {todayActivities.map((activity, index) => <div key={index} className="flex items-center" data-id="element-448">
                <div className="bg-gray-100 rounded-lg w-12 h-12 flex items-center justify-center mr-3" data-id="element-449">
                  <span className="text-sm font-medium" data-id="element-450">{activity.time}</span>
                </div>
                <div data-id="element-451">
                  <h4 className="font-medium text-sm" data-id="element-452">{activity.title}</h4>
                  <p className="text-xs text-gray-600" data-id="element-453">{activity.location}</p>
                </div>
              </div>)}
          </div>
        </div>
        {/* Emergency Contact */}
        <Link to="/contact" className="bg-red-50 border border-red-100 rounded-lg p-3 flex items-center" data-id="element-454">
          <AlertTriangleIcon size={20} className="text-red-500 mr-3" data-id="element-455" />
          <div data-id="element-456">
            <h4 className="font-medium text-sm text-red-700" data-id="element-457">Noodgeval?</h4>
            <p className="text-xs text-red-600" data-id="element-458">Bekijk contactinformatie</p>
          </div>
        </Link>
        {/* About */}
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-459">
          <div className="flex items-center mb-3" data-id="element-460">
            <InfoIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-461" />
            <h3 className="font-bold" data-id="element-462">Over Camping Olympia</h3>
          </div>
          <p className="text-sm text-gray-600" data-id="element-463">
            Een volledig vernieuwde camping (2022) in het Amblèvedal, gericht op
            het buitenleven, gezinnen en jongeren. Geniet van ons zwembad,
            restaurant, panoramaterras en talrijke buitenactiviteiten.
          </p>
        </div>
      </div>
    </div>;
};
const QuickActionButton = ({
  to,
  icon,
  label
}) => {
  return <Link to={to} className="bg-white rounded-lg shadow-sm p-3 flex flex-col items-center justify-center text-center hover:bg-gray-50 transition-colors" data-id="element-464">
      <div className="text-[#f9b30f] mb-1" data-id="element-465">{icon}</div>
      <span className="text-xs" data-id="element-466">{label}</span>
    </Link>;
};
export default Home;